$(document).ready(function () {
  const sliderNavs = $(".b-studio__button");

  $(".b-studio__button").on("click", function () {
    sliderNavs.removeClass("b-studio__button--active");
    $(this).addClass("b-studio__button--active");
    try {
      swiper.slideTo($(this).attr("data-slide"));
    } catch (e) {
      $(".go_to_trial_mini").click();
    }
  });

  $(".b-slider__slide-title").on("click", function () {
    $(".b-slider__slide").removeClass("b-slider__slide--mobile-active");
    $(this).parent().addClass("b-slider__slide--mobile-active");
  });

  $(window).resize(function () {
    if (window.innerWidth < "768") {
      $(".b-slider__slide").removeClass("swiper-slide");
      $(".b-slider__container").removeClass("swiper-container");
      $(".b-slider__wrapper").removeClass("swiper-wrapper");
      // swiper?.destroy();
    } else {
      try{
          // даня почини свайпер а то грязные хаки
          if (!swiper || swiper?.destroyed) {
            $(".b-slider__slide").addClass("swiper-slide");
            $(".b-slider__container").addClass("swiper-container");
            $(".b-slider__wrapper").addClass("swiper-wrapper");
            swiper = new Swiper(".swiper-container", {
              navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
              },
              on: {
                slideChange: function ({ activeIndex }) {
                  sliderNavs.removeClass("b-studio__button--active");
                  if (activeIndex) {
                    $(sliderNavs[activeIndex]).addClass("b-studio__button--active");
                  }
                },
              },
              autoHeight: true,
              noSwiping: true,
            });
          }
      } catch {}
    }
  });

  const prod = false;

  $(".b-slider__form-button--download").on("click", function () {
    const link = $(this).attr("data-link");
    if (link !== "") {
      window.open(link);
    } else {
      return false;
    }
  });

  $('.b-select[data-name="language"], .b-select[data-name="platform"]').on(
    "click",
    function () {
      const lang = $('.b-select[data-name="language"]').attr("data-value");
      const plat = $('.b-select[data-name="platform"]').attr("data-value");

      if (lang == 2 && plat != "") {
        $(".b-slider__form-button--run").show();
      } else {
        $(".b-slider__form-button--run").hide();
      }

      if (lang == 2 && (plat == 0 || plat == 1)) {
        $('.b-select[data-name="format"]').addClass("b-select--inactive");
      } else {
        if (lang != "" && plat != "") {
          $('.b-select[data-name="format"]').removeClass("b-select--inactive");
        }
      }
    }
  );

  $(
    '.b-select[data-name="language"], .b-select[data-name="platform"], .b-select[data-name="format"]'
  ).on("click", function () {
    checkDist();
  });

  // function dischargePlatform() {
  //   $('.b-select[data-name="platform"] span').text(
  //     "--Ð’Ñ‹Ð±ÐµÑ€Ð¸Ñ‚Ðµ Ð¿Ð»Ð°Ñ‚Ñ„Ð¾Ñ€Ð¼Ñƒ--"
  //   );
  //   $('.b-select[data-name="platform"]').attr("data-value", "");
  // }
  //
  // function dischargeLanguage() {
  //   $('.b-select[data-name="language"] span').text(
  //     "--Ð’Ñ‹Ð±ÐµÑ€Ð¸Ñ‚Ðµ ÑÐ·Ñ‹Ðº--"
  //   );
  //   $('.b-select[data-name="language"]').attr("data-value", "");
  // }

  function dischargeFormat() {
    $('.b-select[data-name="format"] span').text(
      "--Ð¤Ð¾Ñ€Ð¼Ð°Ñ‚ Ð´Ð¸ÑÑ‚Ñ€Ð¸Ð±ÑƒÑ‚Ð¸Ð²Ð°--"
    );
    $('.b-select[data-name="format"]').attr("data-value", "");
    $('.b-select[data-name="format"]').removeClass("b-select--confirm");
  }

  $('.b-select[data-name="language"] .b-select__item').on("click", function () {
    dischargeFormat();
    checkDist();
  });

  $('.b-select[data-name="platform"] .b-select__item').on("click", function () {
    dischargeFormat();
    checkDist();
  });
});
